import { render, staticRenderFns } from "./exercise1.vue?vue&type=template&id=0d1ae8b7&"
import script from "./exercise1.vue?vue&type=script&lang=js&"
export * from "./exercise1.vue?vue&type=script&lang=js&"
import style0 from "./exercise1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports